import axiosInstance from "../../apiAxios/axiosInstance";

// Notification Bhejne ke liye
export const sendNotification = async (payload) => {
  const response = await axiosInstance.post("/admin/send-custom-notification", payload);
  return response.data;
};

// Notification History dekhne ke liye
export const getSentNotificationHistory = async (payload) => {
  const response = await axiosInstance.post("/admin/notifications/sent-history", payload);
  return response.data;
};